var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadingDetail,
            expression: "loadingDetail"
          }
        ]
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "wo-detail-wrap" }, [
          _c("div", { staticClass: "wo-status" }, [
            _c("h2", { staticClass: "w-d-detail" }, [
              _vm._v(_vm._s(_vm.workOrderDetail.statuDesc))
            ]),
            _vm._v(" "),
            _vm.workOrderDetail.statu == 0
              ? _c("p", { staticClass: "wo-status-desc" }, [
                  _vm._v(
                    "提问处理中，讯飞工程师会在" +
                      _vm._s(_vm.timeRange) +
                      "内回复您。工作时段为法定工作日的9：00-17：00，中午高峰期会有适当的延迟，敬请谅解。"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "w-s-addition" }, [
              _c("span", [
                _vm._v("工单号：" + _vm._s(_vm.workOrderDetail.code))
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("|")]),
              _vm._v(" "),
              _c("span", [
                _vm._v("提交时间：" + _vm._s(_vm.workOrderDetail.createtime))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wo-record-wrap" }, [
            _c(
              "ul",
              { staticClass: "wo-record" },
              [
                _vm._l(_vm.workOrderDetail.message || [], function(item) {
                  return _c(
                    "li",
                    { key: item.content, staticClass: "record-response new-t" },
                    [
                      _c("div", { staticClass: "record-item-avatar" }, [
                        item.opt == 0
                          ? _c("img", {
                              attrs: {
                                src: require("../../../../assets/iflytek-engineer.png")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.opt == 1
                          ? _c("img", {
                              attrs: {
                                src: require("../../../../assets/question.png")
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "record-info" }, [
                        _c("p", { staticClass: "response-name" }, [
                          _vm._v(
                            _vm._s(
                              item.opt == 0
                                ? _vm.workOrderDetail.customerType
                                : "您"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "response-content",
                          domProps: { innerHTML: _vm._s(item.content) }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "response-attachment" },
                          _vm._l(item.attachments, function(attachmentItem) {
                            return _c("span", { key: attachmentItem.url }, [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: attachmentItem.url,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-document"
                                    }),
                                    _vm._v(" " + _vm._s(attachmentItem.name))
                                  ]
                                )
                              ])
                            ])
                          })
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "response-date" }, [
                          _vm._v(_vm._s(item.createtime))
                        ])
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _c("li", { staticClass: "record-response" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "record-info" }, [
                    _c("p", { staticClass: "response-name" }, [_vm._v("您")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "response-content" }, [
                      _vm._v(_vm._s(_vm.workOrderDetail.title))
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "response-content",
                      domProps: {
                        innerHTML: _vm._s(_vm.workOrderDetail.detail)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "response-attachment" },
                      _vm._l(_vm.workOrderDetail.attachments, function(
                        attachmentItem
                      ) {
                        return _c("span", { key: attachmentItem.url }, [
                          _c("div", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: attachmentItem.url,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("i", { staticClass: "el-icon-document" }),
                                _vm._v(" " + _vm._s(attachmentItem.name))
                              ]
                            )
                          ])
                        ])
                      })
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "response-date" }, [
                      _vm._v(_vm._s(_vm.workOrderDetail.createtime))
                    ])
                  ])
                ])
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _vm.workOrderDetail.statu == 2 && !_vm.isShowAppend
          ? _c(
              "div",
              { staticClass: "detail-option" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.finishWorkOrder()
                      }
                    }
                  },
                  [_vm._v("确认结单")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v("如未解决问题，请\n        "),
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.showAppend }
                    },
                    [_vm._v("继续留言")]
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowAppend ||
        _vm.workOrderDetail.statu == 0 ||
        _vm.workOrderDetail.statu == 1
          ? _c(
              "div",
              { staticClass: "append-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "appendForm",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.appendForm, "label-width": "0px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: " ", prop: "content" } },
                      [
                        _c("el-input", {
                          staticClass: "follow-upload",
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 4, maxRows: 8 },
                            placeholder: "请填写问题描述",
                            "auto-complete": "off"
                          },
                          model: {
                            value: _vm.appendForm.content,
                            callback: function($$v) {
                              _vm.$set(_vm.appendForm, "content", $$v)
                            },
                            expression: "appendForm.content"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ]
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "hidden" },
                              model: {
                                value: _vm.appendForm.fileUrl,
                                callback: function($$v) {
                                  _vm.$set(_vm.appendForm, "fileUrl", $$v)
                                },
                                expression: "appendForm.fileUrl"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "upload-bottom" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                attrs: {
                                  action: "/dashboard/workorder/upload",
                                  accept:
                                    ".jpg,.png,.txt,.rar,.zip,.doc,.xls,.docx,.xlsx,.pdf",
                                  "before-upload": _vm.beforeAvatarUpload,
                                  multiple: true,
                                  "on-change": _vm.handleChange,
                                  "on-remove": _vm.handleFileRemove,
                                  "file-list": _vm.workOrderFiles
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "issue-file-btn",
                                    attrs: { size: "small" }
                                  },
                                  [_vm._v("上传文件")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "file-limit-desc" }, [
                                  _vm._v(
                                    "上传附件支持jpg、png、txt、rar、doc、xls、docx、xlsx、pdf格式，最大不超过5M"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "detail-option" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.submitAppend("appendForm")
                          }
                        }
                      },
                      [_vm._v("提交追问")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "confirm-wo" },
      [
        _c(
          "el-dialog",
          {
            staticStyle: { width: "1000px", margin: "0 auto" },
            attrs: {
              title: "确认结单",
              "close-on-click-modal": false,
              visible: _vm.dialogVisible,
              "before-close": _vm.handleClose
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "confirm-tip" }, [
              _c("span", [
                _c("i", { staticClass: "el-icon-circle-check confirm-icon" })
              ]),
              _vm._v("确认结单后，该问题流程将关闭，请对我们的服务做出评价")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "confirm-form" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.formRules,
                      "label-width": "80px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        class:
                          _vm.form.score <= 4 && !_vm.form.tag.length
                            ? "rate-area-wrong"
                            : "rate-area",
                        attrs: { label: "服务评价", prop: "score" }
                      },
                      [
                        _c("el-rate", {
                          model: {
                            value: _vm.form.score,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "score", $$v)
                            },
                            expression: "form.score"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "tag" } },
                      _vm._l(_vm.commentTags, function(tag) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.value,
                            class: _vm.form.tag.includes(
                              tag.value + _vm.commentLevel
                            )
                              ? "selected-tag"
                              : "comment-tag",
                            attrs: { "disable-transitions": false },
                            on: {
                              click: function($event) {
                                _vm.labelClick(tag)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(tag.text + _vm.commentLevel) +
                                "\n            "
                            )
                          ]
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "评价内容", prop: "content" } },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "200",
                            type: "textarea",
                            resize: "none",
                            placeholder: "请输入评价内容 不超过200字",
                            "auto-complete": "off"
                          },
                          model: {
                            value: _vm.form.content,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "content", $$v)
                            },
                            expression: "form.content"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "confirm-btn-wrap" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "confirm-submit-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.submitRate("form")
                          }
                        }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [_c("span")])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "page-next" }, [
      _c(
        "a",
        { staticClass: "link-item", attrs: { href: "/workorder/myworkorder" } },
        [_c("span", { staticClass: "back-last" })]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("工单详情")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "record-item-avatar" }, [
      _c("img", { attrs: { src: require("../../../../assets/question.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c7738e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7738e9","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Dashboard/WorkOrder/MyWorkOrder/Detail.vue
// module id = 764
// module chunks = 40